
export default {
    //companyPortalUrl:'http://localhost:8080',
   
    //For Stage
    //companyPortalUrl: 'https://stageportal.briktok.com',
    //companyPortalOrigin: 'stageportal.briktok.com',
    //For Live
    companyPortalUrl: 'https://portal.spliyt.com',
    companyPortalOrigin: 'portal.spliyt.com',
};